export class UIDCommunitySceneController {
    hide() {
        this.communitySceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.communitySceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.communitySceneContainerDiv = document.getElementById('scene_discord_community_container');
    }
}
